import { useCallback } from 'react';
import type {
  RankingResult,
  InteractiveContentChoice,
} from '@core-api/presentation/types/response';
import {
  usePreviewResultsIterator,
  getRankingPreviewResultsIteration,
} from '@mentimeter/slides-preview-results';

interface UseRankingPreviewResultsProps {
  isEnabled: boolean;
  choices: InteractiveContentChoice[];
}

export const useRankingPreviewResults = ({
  isEnabled,
  choices,
}: UseRankingPreviewResultsProps): RankingResult[] => {
  const getNextResults = useCallback(
    (iteration: number, previous: RankingResult[] = []) => {
      return getRankingPreviewResultsIteration({
        iteration,
        previous,
        extras: { choices },
      });
    },
    [choices],
  );

  return usePreviewResultsIterator(isEnabled, getNextResults) ?? [];
};
